import React, { useState } from 'react';
import { useFetch } from 'hooks';
import { routes } from 'constants/config';
import { Spinner } from 'ui';
import InputFieldWithSaveButton from 'components/shared/InputFieldWithSaveButton';
import request from 'utils/request_ajax';
import InfoTooltip from 'components/shared/InfoTooltip';
import { BrowserRouter, Switch, Route, useParams } from 'react-router-dom';
import { hasFeatureFlags } from 'utils/features';

const LessonRetakeScoreMaxAttempts = () => {
  const maximumAttemptsFlag = hasFeatureFlags(['learning_maximum_attempts']);
  const { lessonId } = useParams();
  const [waiting, setWaiting] = useState(false);
  const [retakeScore, setRetakeScore] = useState('');
  const [maximumAttempts, setMaximumAttempts] = useState('');
  const [zeroOrNull, setZeroOrNull] = useState('');
  const {
    data: lessonData,
    loading,
    initialLoading,
    runRequest,
  } = useFetch(routes.LESSON(lessonId));

  if (initialLoading) {
    return (
      <div className="d-f ai-c jc-c mb-8">
        <Spinner />
      </div>
    );
  }
  const archived = !!lessonData?.archived_at;
  const maximumAttemptsValue =
    Math.max(Number(0), Math.min(Number(100), Number(maximumAttempts))) ||
    Math.max(
      Number(0),
      Math.min(Number(100), Number(lessonData.maximum_attempts)),
    );
  const maximumAttemptsValueInitial =
    maximumAttempts === '' && maximumAttemptsValue < 1
      ? ''
      : maximumAttemptsValue;
  const retakeScoreValue =
    Math.max(Number(0), Math.min(Number(100), Number(retakeScore))) ||
    Math.max(Number(0), Math.min(Number(100), Number(lessonData.retake_score)));
  const maximumAttemptsActive = lessonData.retake_score < 1 && !archived;
  const retakeScoreClassName = maximumAttemptsFlag
    ? 'SidebarModule-last-child'
    : '';

  const maximumAttemptsChangeHandler = event => {
    setMaximumAttempts(event.target.value);
    if (event.target.value < 1) {
      setZeroOrNull(0);
    } else {
      setZeroOrNull('');
    }
  };

  const updateRetakeScore = value => {
    setWaiting(true);
    const attempts = value < 1 ? 0 : lessonData.maximum_attempts;
    setMaximumAttempts(attempts);
    request
      .postJSON(routes.LESSON_OVERVIEW.UPDATE_LESSON(lessonData.id), {
        id: lessonData.id,
        retake_score: value,
        maximum_attempts: attempts,
      })
      .then(() => {
        runRequest();
        setWaiting(false);
      });
  };

  const updateMaxAttempts = value => {
    setWaiting(true);
    setZeroOrNull('');
    request
      .postJSON(routes.LESSON_OVERVIEW.UPDATE_LESSON(lessonData.id), {
        id: lessonData.id,
        maximum_attempts: value,
      })
      .then(() => {
        runRequest();
        setWaiting(false);
      });
  };

  return (
    <>
      <div className={retakeScoreClassName} id="retake_score">
        <h3 className="Module-heading SectionHeading">
          {archived ? (
            <>
              {t('lesson_overview.retake_score.title')}
              <InfoTooltip
                tooltip={t('archive.uneditable')}
                className="ml-4 tooltip-fixedWidth Module-headingIcon"
              />
            </>
          ) : (
            <>
              {t('lesson_overview.retake_score.title')}
              <InfoTooltip
                tooltip={t('lesson_overview.retake_score.tooltip')}
                className="ml-4 tooltip-fixedWidth Module-headingIcon"
              />
            </>
          )}
        </h3>
        <section id="retake_score_input">
          {waiting ||
            (loading && (
              <div className="d-f ai-c jc-c mt-8">
                <Spinner />
              </div>
            ))}
          <InputFieldWithSaveButton
            active={String(archived)}
            disabled={archived}
            type="number"
            className="SidebarModule-fieldWithButton"
            value={retakeScore < 1 && retakeScore !== '' ? 0 : retakeScoreValue}
            saveButtonHandler={updateRetakeScore}
            onChange={event => setRetakeScore(event.target.value)}
            inputdata={
              retakeScore < 1 && retakeScore !== '' ? 0 : retakeScoreValue
            }
            name="lesson[retake_score]"
          />
        </section>
      </div>
      {maximumAttemptsFlag && (
        <div id="maximum_attempts">
          <h3 className="Module-heading SectionHeading pt-30">
            {archived ? (
              <>
                {t('lesson_overview.maximum_attempts.title')}
                <InfoTooltip
                  tooltip={t('archive.uneditable')}
                  className="ml-4 tooltip-fixedWidth Module-headingIcon"
                />
              </>
            ) : (
              <>
                {t('lesson_overview.maximum_attempts.title')}
                <InfoTooltip
                  tooltip={t('lesson_overview.maximum_attempts.tooltip')}
                  className="ml-4 tooltip-fixedWidth Module-headingIcon"
                />
              </>
            )}
          </h3>
          <section id="maximum_attempts_input">
            {waiting ||
              (loading && (
                <div className="d-f ai-c jc-c mt-8">
                  <Spinner />
                </div>
              ))}
            <InputFieldWithSaveButton
              active={String(maximumAttemptsActive)}
              disabled={archived}
              type="number"
              className="SidebarModule-fieldWithButton"
              value={
                maximumAttempts < 1 && maximumAttempts !== ''
                  ? zeroOrNull
                  : maximumAttemptsValueInitial
              }
              saveButtonHandler={updateMaxAttempts}
              onChange={maximumAttemptsChangeHandler}
              inputdata={
                maximumAttempts < 1 && maximumAttempts !== ''
                  ? zeroOrNull
                  : maximumAttemptsValue
              }
              name="lesson[maximum_attempts]"
            />
          </section>
        </div>
      )}
    </>
  );
};

const LessonRetakeScoreMaxAttemptsRoot = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/lessons/:lessonId"
          component={LessonRetakeScoreMaxAttempts}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default props => <LessonRetakeScoreMaxAttemptsRoot {...props} />;
